export const SCALED_IMAGE_CONFIG = Object.freeze({
  mimeType: 'image/png',
  quality: 1,
  pixelRatio: 2,
})
